module.exports = __webpack_public_path__ + "img/product3.fc6df8cf.png";